import Enumerable from "linq";
import { IUIUserFavoriteModel } from "../../services/ui-personalization-data-service/Models";
import { CheckListItemType } from "../check-list/CheckListItemType";
import { AssignHomePageFieldType } from "./AssignHomePageFieldTypes";
import { IeLynxUser } from "../../common/models/eLynxUser";
import { FieldArrayWithId } from "react-hook-form";
import _ from "lodash";


function _mapToUser(item: IeLynxUser, favorite: IUIUserFavoriteModel | undefined, assignHomePage: boolean): IeLynxUser {

    const user = _.cloneDeep(item);

    user.disabled = assignHomePage ? 
                    user.favorites?.some(o => o.isHomeUrl) :
                    user.favorites?.some(o => _.isEqual(o.routeDetail, favorite?.routeDetail));
    return user;
}

const AssignHomePageDialogUtils = {

createAvailableUserCheckListItems: (availableUsers: FieldArrayWithId<AssignHomePageFieldType, "users", "fieldKey">[],
    selectedIDs: number[]
): CheckListItemType[] => {

    return Enumerable
        .from(availableUsers)
        .select(user => {


            return {
                key: `${user.id}`,
                id: user.id,
                displayText: `${user.lastName}, ${user.firstName}`,
                secondaryText: user.loginName,
                tertiaryText: user.jobFunction,
                disabled: user.disabled ?? false,
                checked: selectedIDs.some(o => o === user.id),
            } as CheckListItemType;
        })
        .orderBy(c => c.displayText.toUpperCase())
        .toArray();
},

    mapToUser: (item: IeLynxUser, assignHomePage: boolean): IeLynxUser =>  {
        return _mapToUser(item, undefined, assignHomePage)
    },
    mapToForm: (model: IeLynxUser[], favorite: IUIUserFavoriteModel, assignHomePage: boolean
    ): AssignHomePageFieldType  => {

        const formValues: AssignHomePageFieldType = {
            users: model.map(o => _mapToUser(o, favorite, assignHomePage))
        };

        return formValues;
    },
    
};

export default AssignHomePageDialogUtils;
